import { PageContainer } from "@ant-design/pro-components";
import { Result } from "antd";

const NotAuthorizedPage = () => {
  return (
    <PageContainer>
      <Result
        style={{ paddingTop: 200 }}
        status="404"
        title="Not Found"
        subTitle="Sorry, Web Page Not Found."
      />
    </PageContainer>
  );
};

export default NotAuthorizedPage;
